import {FunnelBackModule} from "../funnelback/funnelback";

export class SearchOverlayModule {
    constructor(funnelbackModule, mapApiCallbacks) {
        const that = this;
        let bodyOverflow;

        if (that.locationLookupSetup.length !== 0) {
            mapApiCallbacks.push(that.locationLookupSetup);
        }
        
        let searchOverlay = $('.search-overlay');
        $('#search-overlay-close').on('click', function () {
            searchOverlay.hide();
            $('body').css('overflow', bodyOverflow);

            $('#search-overlay-text-input').val('');
            $('#search-overlay-location-input').val('');
            $('#search-overlay-location-input-geo').val('');
            that.clearAndHideSuggestions();            
        });
        
        $('.open-overlay-search-button').on('click', function () {
            searchOverlay.show();
            let body = $('body');
            bodyOverflow = body.css('overflow');
            body.css('overflow', 'hidden');
        });
        
        $('#search-overlay-submit').on('click', function () {
            that.search();
        });
        
        $('#search-overlay-text-input').on('input', function() {            
            funnelbackModule.requestAutocompleteResults($(this).val(), function (data) {
                let list = $('#search-overlay-suggestion-list');
                
                if(data.length < 1) {
                    that.clearAndHideSuggestions();
                    return;
                }
                
                $('.search-overlay-suggestions-container').show();
                
                list.html('');

                for (let i = 0; i < data.length; i++) {
                    list.append(`<li>${data[i].disp}</li>`);
                    if(i === 8) {
                        break;
                    }
                }
            })
        });
        
        $('#search-overlay-suggestion-list').on('click', 'li', function () {
            let input = $('#search-overlay-text-input');
            input.val($(this).text());
            input.trigger('input');
            that.search();
        });
        
        $('#search-overlay-text-input').on('keydown', function(e) {
            if(e.keyCode === 13) {
                that.search();
            }
        });
        
        $('#search-overlay-location-mylocation').on('click', function() {
            let setLocation = function (position) {
                $('#search-overlay-location-input').val('My Location');
                $('#search-overlay-location-input-geo').val(position.coords.latitude + ';' + position.coords.longitude)
            }
            
           if(navigator.geolocation) {
               navigator.geolocation.getCurrentPosition(setLocation);
           }
        });
        
        $('#clear-search').on('click', function () {
            $('#search-overlay-text-input').val("");
        }); 
    }
    
    search() {
        let query = $('#search-overlay-text-input').val();
        let origin = $('#search-overlay-location-input-geo').val();
        
        if(query.length > 0) {
            window.location.href = '/search/?query=' + encodeURIComponent(query);
        }        
    }
    
    locationLookupSetup() {
        const lookup = document.querySelector('.location-lookup-input');
        const options = {
            fields: ["formatted_address", "geometry", "name"],
            strictBounds: false,
            componentRestrictions: { 'country': 'gb' },
            types: ['geocode']
        };

        const autocomplete = new google.maps.places.Autocomplete(lookup, options);

        autocomplete.addListener("place_changed", function () {
            let place = autocomplete.getPlace();
            let latlong = place.geometry.location;
            $('#' + lookup.id + '-geo').val(latlong.lat() + ';' + latlong.lng());
        });
    }
    
    clearAndHideSuggestions() {
        $('#search-overlay-suggestion-list').html('');
        $('.search-overlay-suggestions-container').hide();
    }
}